export const STATUS = {
  '已处理': '已处理',
  '开票中': '开票中'
};
export const STATUS_zh = {
  '已处理': '已处理',
  '开票中': '待处理',
};
export const TYPE = {
  PERSONAL: 'PERSONAL',
  ENTERPRISE: 'ENTERPRISE'
};
export const TYPE_zh = {
  PERSONAL: '个人身份认证',
  ENTERPRISE: '企业资质认证'
};
